import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
//import ReactDOM from 'react-dom';
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "App";
import reportWebVitals from "./reportWebVitals";
import store from "store/store";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";
import "@fontsource/roboto"; // Defaults to weight 400.
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-N9VWKVP",
  dataLayerName: "Vales",
};

TagManager.initialize(tagManagerArgs);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
serviceWorker.unregister();
